
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[store]/product/[id]/retail",
      function () {
        return require("private-next-pages/[store]/product/[id]/retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[store]/product/[id]/retail"])
      });
    }
  